export const clientLogos = {
  title: "Trusted by Contractors Across the Industry",
  subtitles: "Our Clients",
  description:
    "We’re proud to work with contractors and construction businesses across North America.",
  logos: [
    {
      name: "Bravo Site Works",
      image: "assets/logos/BravoSiteLogo.png",
    },
    {
      name: "Crete Co",
      image: "assets/logos/CreteCoLogo.png",
    },
    {
      name: "Fletco Construction",
      image: "assets/logos/FletcoConstructionLogo.png",
    },
    {
      name: "Freedom Fabrication & Excavation",
      image: "assets/logos/FreedomLandscapingLogo.png",
    },
    {
      name: "Keith Baker Construction",
      image: "assets/logos/KeithBakerCLogo.png",
    },
    {
      name: "Magers Excaviation",
      image: "assets/logos/MagersExcavationLogo.png",
    },
    {
      name: "APEX",
      image: "assets/logos/APEX.jpg",
    },
    {
      name: "Cornerstone",
      image: "assets/logos/Cornerstone.png",
    },
    {
      name: "Gulfstream",
      image: "assets/logos/Gulfstream.png",
    },
    {
      name: "Hensley",
      image: "assets/logos/Hensley.png",
    },
    {
      name: "Miller",
      image: "assets/logos/Miller.jpg",
    },
    {
      name: "Pace",
      image: "assets/logos/Pace.jpg",
    },
    {
      name: "Rosebrooke",
      image: "assets/logos/Rosebrooke.png",
    },
    {
      name: "RX Lodge",
      image: "assets/logos/RX Lodge.png",
    },
    {
      name: "S&S Rock Crushing",
      image: "assets/logos/S&S Rock Crushing.jpg",
    },
    {
      name: "Uppervalley",
      image: "assets/logos/uppervalley-logo.png",
    },
  ],
};
